import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { log, UIComponents } from '@ntap/core';
import { combineLatest, Subscription } from 'rxjs';
/*
 * A custom list view component that shows its data depending on the currently active route
 */
@Component({
  selector: 'app-main-listview',
  templateUrl: './main-listview.html',
  styleUrls: ['./main-listview.scss']
})
export class MainListViewComponent implements OnInit, OnDestroy {
  INIT_COMP_ID = UIComponents.LISTVIEW;
  currentViewName: string;
  currentViewState: object | null = null;
  currentViewStateFilter: object = {};
  currentViewClass: string;

  routeChangeSubscription: Subscription;

  constructor(protected route: ActivatedRoute) {}

  ngOnInit() {
    this.subscribeToRouteChange();
  }

  ngOnDestroy(): void {
    this.unsubscribeFromRouteChange();
  }

  subscribeToRouteChange() {
    log('subscribe to route params');
    this.routeChangeSubscription = combineLatest([
      this.route.data,
      this.route.paramMap
    ]).subscribe(([data, paramsMap]) => {
      const strViewName = paramsMap.get('viewName') || data['viewName'];
      if (strViewName) {
        log('param change');
        this.changeView(strViewName);
      }
    });
  }

  unsubscribeFromRouteChange(): any {
    log('Unsubsubscribe from route params');
    if (this.routeChangeSubscription) {
      this.routeChangeSubscription.unsubscribe();
    }
  }

  changeView(viewName: string) {
    log(`CHANGE NEW view: ${viewName}`);
    this.currentViewName = viewName;
    this.currentViewState = {};
    this.currentViewStateFilter = {};
    this.currentViewClass = 'list-view-' + viewName;
  }
}
